import React from 'react'
import useState from '@hooks/useState'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import CloseIcon from './CloseIcon'
import Icon from './Icon'

import styles from './styles.module.css'

function Alert(props) {
  const {type, title, description, showIcon, showClose, animated, children} = props
  const [show, setShow] = useState(true)

  if (!show) return null

  return (
    <div
      className={classnames(styles.container, styles[`bg-${type}`], {
        [styles.animation]: animated
      })}>
      <Icon
        show={showIcon}
        type={type}
        className={classnames(styles[`color-${type}`], styles.icon)}
      />

      <div className={styles.subContainer}>
        {title ? <span className={styles.title}>{title}</span> : null}
        {description ? <span className={styles.description}>{description}</span> : null}
        {children ? <div>{children}</div> : null}
      </div>

      <CloseIcon
        show={showClose}
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ show: any; className: string; onClick: () ... Remove this comment to see the full error message
        className={classnames(styles[`color-${type}`], styles.closeIcon)}
        onClick={() => setShow(false)}
      />
    </div>
  )
}

Alert.propTypes = {
  type: PropTypes.oneOf(['info', 'danger', 'warning', 'success']),
  title: PropTypes.string,
  description: PropTypes.string,
  showIcon: PropTypes.bool,
  showClose: PropTypes.bool,
  animated: PropTypes.bool,
  children: PropTypes.node
}

Alert.defaultProps = {
  type: 'info',
  showIcon: true,
  showClose: false,
  animated: false
}

export default Alert
